module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.activePairingData) ? _c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Confirm Payout")]), _vm._v(" "), _c('v-card-text', [_c('a', {
    staticClass: "title",
    attrs: {
      "href": 'https://www.instagram.com/' + _vm.activePairingData.instagramHandle,
      "target": "_blank"
    }
  }, [_vm._v("@" + _vm._s(_vm.activePairingData.instagramHandle))]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hide-details": "",
      "prefix": "S$"
    },
    on: {
      "input": function($event) {
        return _vm.$v.activePairingData.payout.$touch()
      }
    },
    model: {
      value: (_vm.activePairingData.payout),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "payout", _vm._n($$v))
      },
      expression: "activePairingData.payout"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "remarks",
      "label": "Remarks",
      "hide-details": "",
      "value": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.activePairingData.remarks.$touch()
      }
    },
    model: {
      value: (_vm.activePairingData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.activePairingData, "remarks", $$v)
      },
      expression: "activePairingData.remarks"
    }
  })], 1)], 1), _vm._v(" "), (_vm.activePairingData.history.length > 0) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('h4', [_vm._v("Payout History")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Date Time")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Old Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("New Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Remark")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Invoice")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activePairingData.history), function(item, fileIndex) {
          return _c('tr', {
            key: item.timestamp
          }, [_c('td', [_vm._v(_vm._s(_vm.formatTime(item.timestamp)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.old_amount)))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remarks))]), _vm._v(" "), _c('td', [(item.invoices) ? _c('div', _vm._l((item.invoices), function(invoice, index) {
            return _c('v-btn', {
              key: index,
              attrs: {
                "text": "",
                "color": "warning",
                "href": invoice.url,
                "target": "_blank"
              }
            }, [_vm._v("\n                        View PDF\n                      ")])
          }), 1) : _vm._e()]), _vm._v(" "), _c('td', [_c('v-btn', {
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Delete Payout",
              "color": "error",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.deletePayout(fileIndex)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "white",
              "small": ""
            }
          }, [_vm._v("delete")])], 1)], 1)])
        }), 0)]
      },
      proxy: true
    }], null, false, 1998547521)
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": "",
      "disabled": _vm.viewOnly
    },
    on: {
      "click": function($event) {
        return _vm.processConfirmPayout()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('influencer-detail-modal', {
    attrs: {
      "dialog": _vm.invoiceDialog,
      "influencer": _vm.influencer,
      "isGetInvoice": _vm.isGetInvoice,
      "close": _vm.closeModal
    },
    on: {
      "generatedInvoice": _vm.confirmPayout
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0317fb09"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/PayoutConfirmModal.vue
// module id = 1973
// module chunks = 0